import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">
            分类浏览
          </span>
          <h2 className="mt-2 text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            探索你喜欢的题材
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            十大分类，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-2xl bg-background-100 hover:bg-primary-50 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="mt-3 text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                {cat.count}部
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}